import { Row } from 'components/ui/atoms';
import { Zap } from 'components/ui/atoms/icons';
import { Button } from 'components/ui/molecules';
import { routes, shouldShowRobinWrapped } from 'config';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { default as Logo } from 'shared/legacy/components/Logo';
import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';

import { RobinJrAppToggle } from '@/shared/ui/robin-jr-app-toggle';
import { usePageContext } from 'hooks/shared/usePageContext';
import { PageContext } from 'hooks/shared/usePageContext.types';
import { useRobinJrAppStore } from 'shared/config/useRobinJrApp';
import { ConfigContext } from 'shared/legacy/contexts/ConfigContext/ConfigContext';
import { LandingPageContext } from 'shared/legacy/contexts/LandingPageContext';
import { useFeatureToggles } from 'shared/legacy/hooks/useFeatureToggles';
import { useContextSelector } from 'use-context-selector';
import { SearchInputLazy } from '../SearchInput/SearchInput.lazy';
import { NavBarSidebarSpacer } from './NavBarSidebarSpacer';
import KnowledgeBaseButton from './components/KnowledgeBaseButton';
import { NewMessageReplies } from './components/NewMessageReplies/NewMessageReplies';
import { NotificationsBell } from './components/NotificationsBell/NotificationsBell';
import { UserMenu } from './components/UserMenu/UserMenu';
import { useStyles } from './styles';

export const NavBar = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const pageContext = usePageContext();
  const { dictionary } = useContext(LocalizationContext);
  const isHomePage = pageContext === PageContext.Home;
  const isShowingLandingPage = useContextSelector(LandingPageContext, (state) => state.isShowingLandingPage);
  const isIframe = useContextSelector(ConfigContext, (state) => state.isIframe);
  const showNavBar = useContextSelector(ConfigContext, (state) => state.showNavbar);
  const isRobinJrApp = useRobinJrAppStore((s) => s.isRobinJrApp);
  const { isFeatureToggleEnabled } = useFeatureToggles();

  const isRobinJrAppToggleEnabled = isFeatureToggleEnabled((f) => f.ROBIN_JR_CHAT);

  return (
    <Row css={[classes.root, isIframe && classes.iframeRoot]} alignCenter left spaceBetween>
      <div css={classes.logoContainer}>
        <div css={classes.buttons}>
          <Logo variant={'text'} />
          {isRobinJrAppToggleEnabled && <RobinJrAppToggle />}
          {shouldShowRobinWrapped() && (
            <Button
              variant="highlight"
              icon={<Zap />}
              label={<u>{dictionary.robinYearWrapped({ year: new Date().getFullYear() })}</u>}
              onClick={() => [navigate(routes.robinWrapped)]}
            />
          )}
        </div>
        <NavBarSidebarSpacer />
      </div>

      {!isHomePage && !isShowingLandingPage && ((isIframe && showNavBar) || !isIframe) && !isRobinJrApp && (
        <SearchInputLazy />
      )}

      <Row css={classes.controlsContainer} alignCenter>
        <NewMessageReplies />
        <NotificationsBell />
        <KnowledgeBaseButton />
        <div css={classes.divider} />
        <UserMenu />
      </Row>
    </Row>
  );
};
